export default {
  'Please select an output format': 'Veuillez sélectionner un format de sortie',
}